const CACHE_KEY = "foon_currency_cache";
const CACHE_TTL = 3600000;

const API_KEY = process.env.REACT_APP_EXCHANGE_RATE_API_KEY || "DUMMY_KEY";

export const SUPPORTED_CURRENCIES = ["USD", "EUR", "GBP"];

export const CURRENCY_SYMBOLS = {
  USD: "$",
  EUR: "\u20AC",
  GBP: "\u00A3",
};

const COUNTRY_TO_CURRENCY = {
  US: "USD",
  GB: "GBP",
  AT: "EUR", BE: "EUR", CY: "EUR", EE: "EUR", FI: "EUR", FR: "EUR",
  DE: "EUR", GR: "EUR", IE: "EUR", IT: "EUR", LV: "EUR", LT: "EUR",
  LU: "EUR", MT: "EUR", NL: "EUR", PT: "EUR", SK: "EUR", SI: "EUR",
  ES: "EUR", HR: "EUR",
};

function getCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (Date.now() - parsed.timestamp > CACHE_TTL) return null;
    return parsed;
  } catch {
    return null;
  }
}

function setCache(data) {
  try {
    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ ...data, timestamp: Date.now() }),
    );
  } catch {
    // storage full or unavailable
  }
}

async function detectCountry() {
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (!res.ok) return "US";
    const data = await res.json();
    return data.country_code || "US";
  } catch {
    return "US";
  }
}

async function fetchRates() {
  try {
    const res = await fetch(
      `https://v6.exchangerate-api.com/v6/${API_KEY}/latest/USD`,
    );
    if (!res.ok) return { USD: 1, EUR: 0.92, GBP: 0.79 };
    const data = await res.json();
    const rates = {};
    SUPPORTED_CURRENCIES.forEach((c) => {
      rates[c] = data.conversion_rates?.[c] || 1;
    });
    return rates;
  } catch {
    return { USD: 1, EUR: 0.92, GBP: 0.79 };
  }
}

export async function detectCurrency() {
  const cached = getCache();
  if (cached) return { currency: cached.currency, rates: cached.rates };

  const [countryCode, rates] = await Promise.all([
    detectCountry(),
    fetchRates(),
  ]);

  const currency = COUNTRY_TO_CURRENCY[countryCode] || "USD";
  setCache({ currency, rates });
  return { currency, rates };
}

export function parsePriceToNumber(priceString) {
  if (typeof priceString === "number") return priceString;
  return parseFloat(String(priceString).replace(/[^0-9.]/g, "")) || 0;
}

export function formatPrice(basePriceUSD, targetCurrency, rates) {
  const numericBase = parsePriceToNumber(basePriceUSD);
  const rate = rates?.[targetCurrency] || 1;
  const converted = numericBase * rate;
  const symbol = CURRENCY_SYMBOLS[targetCurrency] || "$";

  return `${symbol}${converted % 1 === 0 ? converted.toLocaleString() : converted.toFixed(2)}`;
}

export function updateCurrencyCache(currency, rates) {
  setCache({ currency, rates });
}
